// removed by extract-text-webpack-plugin
module.exports = {"appList":"_3hJJ8bL1uwsRAX5B7UwA1N","upgradeHook":"_3CXpntltZgHPyy2gMFPfWO","apps":"_3aRmMAQIllb9f2Atb94Y0L","moreIcon":"Fb8Mxje-oVvOjVOaHDHBD","overflowIcon":"_1yVYx2vv8u4B9hx711xPu_","hide":"_3WcZ6oR9ib41kVoxZUN1lf","overflowIconContainer":"ltN7At6wSkiWsu6WlTCLf","top":"_1xwPXsSAZD9WM-ZahHWVUn ltN7At6wSkiWsu6WlTCLf","bottom":"_2JqHQqTxfEC4DRK9AZBi6F ltN7At6wSkiWsu6WlTCLf","browseAppsIcon":"_1BXjO6A-ofsepFTfaHPYUS","sortableHelper":"_21Pr9ZUJ1sChm3-3Ddt6H1","upgrade":"FBMq-f5GACD-tUxtoOAvH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/appList/AppList.css
// module id = 470
// module chunks = 0